export const APP_STATUS_ERROR = -1

export const CHARACTER_WHITESPACE = ' '

export const CHARACTER_NON_BREAKING_SPACE = ' '

export const EMPTY_STRING = ''

export const EMPTY_LIST = Object.freeze([])

export const EMPTY_OBJECT = Object.freeze({})

export const EMPTY_FUNCTION = (...args) => void args

export const EMPTY_FUNCTION_ASYNC = (...args) => Promise.resolve(void args)

export const HOST_NAME_LOCALHOST = 'localhost'

export const IDWELL_WEBSITE_URL = 'https://www.idwell.com/'

export const SYMBOL_HYPHEN = '-'

export const NOTIFICATION_TYPE = {
  error: 'error',
  info: 'info',
  success: 'success',
  warning: 'warning',
}

export const FLOATING_ELEMENT_PLACEMENT = {
  bottom: 'bottom',
  bottomEnd: 'bottom-end',
  bottomStart: 'bottom-start',
  left: 'left',
  leftEnd: 'left-end',
  leftStart: 'left-start',
  right: 'right',
  rightEnd: 'right-end',
  rightStart: 'right-start',
  top: 'top',
  topEnd: 'top-end',
  topStart: 'top-start',
}

export const FLOATING_ELEMENT_VIEWPORT_PADDING = 16

export const GRADIENT_POINTS_COUNT = 13

export const SCROLL_CONTENT_CLASS_NAME = 'scroll-content' // Used for scrollable mark html tag. In future should be removed

export const SCROLL_INTO_VIEW_TO_TOP = {
  behavior: 'smooth',
  block: 'start',
}

export const SCROLL_INTO_VIEW_TO_NEAREST = {
  block: 'nearest',
}

export const COOKIE_NAME_TOKEN = 'idw_token'

export const INPUT_AUTOCOMPLETE_VALUE = {
  newPassword: 'new-password',
  off: 'off',
  on: 'on',
}

export const RECAPTCHA_SITE_KEY = '6LfGHjcfAAAAAGo0bkORaIhzWOlS1qMBWP8aHgOz' // Probably should be in env constants

export const PHONE_INTERNATIONAL_FORMAT_SYMBOL = '+'

export const ENTITY_KEY_UUID = 'uuid'

export const ENTITY_KEY_ID = 'id'

export const SCROLL_KEYS = new Set([
  'ArrowDown',
  'ArrowUp',
  'PageDown',
  'PageUp',
  'Home',
  'End',
  ' ',
  'Space',
  'Spacebar',
])

export const NUMBER_FORMAT_LOCALE = 'de-DE'

export const ENTITY_LISTING_VIEW_TYPE = {
  board: 'board',
  boardWithPreview: 'board-with-preview',
  calendar: 'calendar',
  calendarWithPreview: 'calendar-with-preview',
  table: 'table',
  tableWithPreview: 'table-with-preview',
}

export const MODAL_ID_DEFAULT = 'default'

export const Language = {
  de: 'de',
  en: 'en',
}

// Audience variants of a UI language (`de_in`, `de_ofc`, …) share the base language.
export const LANGUAGE_VARIANT_SEPARATOR = '_'

export const IntlListFormatType = {
  conjunction: 'conjunction',
  disjunction: 'disjunction',
  unit: 'unit',
}

// `$$typeof` symbols carried by React element and portal *instances*, as opposed
// to renderable component-type wrappers (forwardRef, memo, lazy, …).
export const REACT_INSTANCE_TYPEOF_SYMBOLS = [
  Symbol.for('react.element'),
  Symbol.for('react.portal'),
]
